module.exports = "<p>\n  update-translation works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/translation/update-translation/update-translation.component.html
// module id = ../../../../../src/app/components/pages/translation/update-translation/update-translation.component.html
// module chunks = main